// extracted by mini-css-extract-plugin
export default {"items":"Variables_items__1MnEF","item":"Variables_item__M2iXn"};